import React from 'react'
import {Box, Typography,Avatar,Button,Badge } from "@mui/material";
import {stringAvatar} from '../utils/avatar.js'

function AgentsList({enabledAgents,handleSendMessage}) {
  return (
    <Box sx={{position: 'relative',display: 'flex',flexDirection: 'column',background: '#FFFFFF',flexGrow:1}}>
        <Box 
            sx={{ 
                overflowY: 'auto',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                scrollbarWidth: "none", // Firefox
                "msOverflowStyle": "none", // IE and Edge
                "&::-webkit-scrollbar": {
                    width: "0.4em", // Adjust as needed
                },
                "&::-webkit-scrollbar-track": {
                    background: "transparent", // Make the track invisible
                },
                "&::-webkit-scrollbar-thumb": {
                    background: "transparent", // Make the thumb (scrollbar) invisible
                }
            }}
        > 
            <Box
                sx={{
                display:'flex',
                flexDirection:'column',
                justifyContent:'left',
                }}
            >
           
                {enabledAgents.map((agent, index) => (
                    <Box
                        sx={{
                        display:'flex',
                        flexDirection:'row',
                        justifyContent:'left',
                        alignItems:'center',
                        gap:2,
                        p:2,
                        borderBottom:'1px solid #E5E5E5'
                        }}
                    >
                        <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            variant="dot"
                            sx={{
                                '& .MuiBadge-dot': {
                                    backgroundColor: '#2CC84A',
                                },
                            }}
                        >
                            <Avatar 
                            {...stringAvatar(agent.name || "Agent")}
                            onClick={() => handleSendMessage(agent?.redirectNumber,false)}
                            />
                        </Badge>
                        <Typography
                            sx={{
                                fontFamily:'DM Sans Medium',
                                fontSize:'16px',
                                color:'#008169',
                            }}
                        >
                            {agent.name}
                        </Typography>
                        <Button
                            contained
                            size="small"
                            sx={{
                            ml:'auto',
                            minWidth:'80px',
                            fontFamily:'DM Sans Bold',
                            background:'#008169',
                            color:'#FFFFFF',
                            textTransform:'none',
                            '&:hover': {
                                background: '#008169',
                                color: '#FFFFFF',
                            },
                            }}
                            onClick={()=>{handleSendMessage(agent?.redirectNumber,false)}}
                        >
                            Chat
                        </Button>  
                    </Box>
                ))}
            </Box>
        </Box>
    </Box>
  )
}

export default AgentsList